import {Component, OnInit, ViewChild, AfterViewInit} from '@angular/core';
import {LanguageModel} from '../../models/language.model';
import {PublicationModel} from '../../models/publication.model';
import {UserModel} from '../../models/user.model';
import * as moment from 'moment';
import {HistoryModel, HistoryPageAbleModel} from '../../models/historyModel';
import {ActionTypePipe} from '../../pipes/actionType.pipe';
import {I18nService} from '../../../shared/i18n';
import {HistoryService} from '../../services/history.service';
import {ReportService} from '../../services/report.service';
import * as FileSaver from 'file-saver';
import {NotificationService} from '../../../shared/utils/notification.service';
import {AppCommunicationService} from '../../services/app-communication.service';
import {ActionTypeCodebook} from '../../codebook/action-type-codebook';
import {DataTable} from 'primeng/primeng';
import {HistoryQueryModel} from '../../models/query.model';

@Component({
    selector: 'app-action-history-list-view',
    templateUrl: './action-history-list-view.component.html',
    styleUrls: ['./action-history-list-view.component.scss']
})
export class ActionHistoryListViewComponent implements OnInit {
    pTable = {
        colNumber: 5,
        expandedRows: {}
    };

    filterButtons = [
        {
            text: 'ActionsHistory',
            active: true,
            color:'bg-color-blueDark'
        },
        {
            text: 'ReportsHistory',
            active: false,
            color:'bg-color-teal'
        },
    ];
    yearFilter = {
        data: [],
        settings: {
            singleSelection: false,
            idField: 'item_id',
            textField: 'item_text',
            selectAllText: 'Označiť všetko',
            unSelectAllText: 'Odznačiť všetko',
            itemsShowLimit: 1,
            allowSearchFilter: false
        }
    };

    filter = {
        text: '',
        year: [],
        type: [],
        state: 0
    };
    filterAction = {
        search: '',
        year: [],
        state: 0,
        page:1,
        pageSize:15,
        totalItems: 1
    };
    loading = true;
    showReports=false;
    actionHistory: HistoryModel[] = [];
    allReportHistory: HistoryModel[] = [];
    filtredReportHistory: HistoryModel[] = [];
    @ViewChild('dt') dataTable: DataTable;

    constructor(private actionTypePipe: ActionTypePipe,
                private i18nService: I18nService,
                private historyService:HistoryService,
                private notificationService: NotificationService,
                private reportService:ReportService,
                private _appCommunicationService: AppCommunicationService) {
    }

    ngOnInit() {
        this.generateYearsFilter();
      //  this.filterDataAction();
    }

    ngAfterViewInit() {
        let timeout = null;
        const textInput = <HTMLInputElement>document.getElementById('search');
        textInput.onkeyup = () => {
            if(this.showReports) {
                this.filterDataReports()
            } else {
                clearTimeout(timeout);
                timeout = setTimeout(() => {
                    this.filterAction.search = textInput.value;
                    if(this.filterAction.search.length === 0 || this.filterAction.search.length > 2) {
                        this.filterDataAction();
                    }
                }, 500)
            }
        }
    }

    filterData() {
        if(!this.showReports) {
            this.getActions();
        } else {
            this.getReports();
        }

    }

    filterDataReports() {
        this.filtredReportHistory = this.allReportHistory;
        this.filterByType();
        this.filterByYear();
        this.filterByText();
    }

    setPage(pageInfo) {
        this.filterAction.page = (pageInfo.first + pageInfo.rows) / 15;
        this.filterDataAction(false);
    }

    filterDataAction(resetPagination = true) {
        if (resetPagination)  {
            this.filterAction.page=1;
            this.dataTable.first=0;
        }
        this.getActions();
    }


    onFilterButtonClick(index: number) {
       if(index===0) {
           this.filterButtons[0].active=true;
           this.filterButtons[1].active=false;
           this.showReports=false
           this.getActions();
       } else {
           this.getReports();
           this.filterButtons[0].active=false;
           this.filterButtons[1].active=true;
           this.showReports=true;
       }
    }
    filterByYear() {
        this.filtredReportHistory = this.filtredReportHistory.filter(action =>
            this.filter.year.some(year => year.item_id === action.createdDatetime.getFullYear())
        );
    }

    onSelectAllYears(value) {
        this.filter.year.push(value);
        this.filterDataReports();
    }

    onDeselectAllYears() {
        this.filter.year = [];
        this.filterDataReports();
    }

    onSelectAllTypes(value) {
        this.filter.type.push(value);
        this.filterDataReports();
    }

    onDeselectAllTypes() {
        this.filter.type = [];
        this.filterDataReports();
    }

    generateYearsFilter() {
        let initYear = Number.parseInt(moment(Date.now()).format('YYYY'));
        const endYear = 2010;

        while (initYear >= endYear) {
            this.yearFilter.data.push({
                item_id: initYear,
                item_text: initYear.toString()
            });
            if (initYear === Number.parseInt(moment(Date.now()).format('YYYY'))) {
                this.filter.year.push({
                    item_id: initYear,
                    item_text: initYear.toString()
                });
            }
            initYear--;
        }
    }

    filterByText() {
        if (this.filter.text !== '') {
            const val = this.filter.text.toLowerCase();

            this.filtredReportHistory = this.filtredReportHistory.filter(function (d) {
                return !val || ['createdBy'].some((field: any) => {
                    return d[field].name.toLowerCase().indexOf(val) !== -1
                })|| ['createdBy'].some((field: any) => {
                    return d[field].surname.toLowerCase().indexOf(val) !== -1
                })|| ['createdBy'].some((field: any) => {
                    return (d[field].name.toLowerCase()+' '+d[field].surname.toLowerCase()).indexOf(val) !== -1
                })|| ['publications'].some((field: any) => {
                    return d[field].some(p=>p.title.toLowerCase().indexOf(val) !== -1)
                })||['publications'].some((field: any) => {
                    return d[field].some(p=>p.isbn===null?false:p.isbn.toLowerCase().indexOf(val) !== -1)
                })
            });
        }
    }

    filterByType() {
        if (this.filter.type.length !== 0) {
            this.filtredReportHistory = this.filtredReportHistory.filter(action => action.historyType === this.filter.type[0].item_id)
        }
    }
    onDownloadIsbnReport(rowData:HistoryModel) {
        setTimeout(() => {
            this._appCommunicationService.loadingOn(this.i18nService.getTranslation('Downloading report'));
        });
        // const idReport=+(rowData.id.split('-')[1]);
        const idReport= Number.parseInt(rowData.id);
        this.reportService.downloadIsbnReport(idReport).subscribe(
            (data:Blob)=> {
                FileSaver.saveAs(data, 'isbnReport.pdf');
                this._appCommunicationService.loadingOff();
            },err=> {
                console.error(err);
                this._appCommunicationService.loadingOff();
                this.notificationService.smallBox({
                    title: this.i18nService.getTranslation('error'),
                    color: '#923837',
                    iconSmall: 'fa fa-warning fa-2x fadeInRight animated',
                    content: this.i18nService.getTranslation('somethingIsWrongError'),
                    timeout: 10000
                });
            });
    }

    onDownloadPrints(rowData:HistoryModel,type:string) {
        setTimeout(() => {
            this._appCommunicationService.loadingOn(this.i18nService.getTranslation('Downloading report'));
        });
        let rest;
        const idReport= Number.parseInt(rowData.id);
        switch (type) {
            case 'all':{
                rest = this.reportService.downloadPrintReport(idReport);
                break;
            }
            case 'ke':{
                rest = this.reportService.downloadKePrintReport(idReport);
                break;
            }
            case 'ba':{
                rest = this.reportService.downloadBaPrintReport(idReport);
                break;
            }
            case 'mt':{
                rest = this.reportService.downloadMtPrintReport(idReport);
                break;
            }
            case 'SVK_BB':{
                rest = this.reportService.downloadSvkBbPrintReport(idReport);
                break;
            }
            case 'SVK_KE':{
                rest = this.reportService.downloadSvkKePrintReport(idReport);
                break;
            }
            case 'SVK_PO':{
                rest = this.reportService.downloadSvkPoPrintReport(idReport);
                break;
            }
            case 'UK_SAV_BA':{
                rest = this.reportService.downloadUkSavBaPrintReport(idReport);
                break;
            }
            case 'PK_NRSR':{
                rest = this.reportService.downloadPkNrsrPrintReport(idReport);
                break;
            }
            case 'CVTI_SR':{
                rest = this.reportService.downloadCvtiSrPrintReport(idReport);
                break;
            }
        }
        rest.subscribe(
            (data:Blob)=> {
                FileSaver.saveAs(data, 'printsReport('+type+').pdf');
                this._appCommunicationService.loadingOff();
            },err=> {
                console.error(err);
                this._appCommunicationService.loadingOff();
                this.notificationService.smallBox({
                    title: this.i18nService.getTranslation('error'),
                    color: '#923837',
                    iconSmall: 'fa fa-warning fa-2x fadeInRight animated',
                    content: this.i18nService.getTranslation('somethingIsWrongError'),
                    timeout: 10000
                });
            });
    }

    private getActions() {
        this.loading=true;
        const query = new HistoryQueryModel();
        query.page = this.filterAction.page;
        query.pageSize = this.filterAction.pageSize;
        query.searchText = this.filterAction.search;
        query.years =  this.filter.year.map(year => year.item_id );
        this.historyService.getActionHistory(query).subscribe((data:HistoryPageAbleModel)=> {
            data.items.forEach(h=>h.createdDatetime=new Date(h.createdDatetime));
            this.actionHistory=data.items;
            this.filterAction.totalItems=data.totalItems;
            this.filterDataReports();
            this.loading=false;
        },(err) => {
            console.error(err);
            this.loading=false;
        });
    }
    private getReports() {
        setTimeout(() => {
            this._appCommunicationService.loadingOn(this.i18nService.getTranslation('Loading data'));
        });
        this.historyService.getReportsHistory().subscribe((data:HistoryModel[])=> {
            data.forEach(h=>h.createdDatetime=new Date(h.createdDatetime));
            this.allReportHistory=data;
            this.filterDataReports();
            this._appCommunicationService.loadingOff();
        },(err) => {
            console.error(err);
            this._appCommunicationService.loadingOff();
        });
    }
}




// WEBPACK FOOTER //
// ./src/app/+app-custom/views/action-history-list-view/action-history-list-view.component.ts